define.alias("shared/components/shared/social-set-icons", "settings/components/shared/social-set-icons");